import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { get } from 'lodash';

import {
  PdfSettingsCustomImageModel,
  PdfSettingsFooterInfoModel,
  PdfSettingsCustomTextModel,
  PdfSettingsModel
} from '../../models';
import { PdfSettingsAlignEnum, PdfSettingsFooterBlocksEnum, PdfSettingsFooterInfoBlocksEnum } from '../../enums';
import { CompanyProfile } from '../../../administration/models/company-profile.model';
import { BankAccountModel } from '../../../bank-accounts/models';

@Component({
  selector: 'rnpl-pdf-footer',
  templateUrl: './pdf-footer.component.html',
  styleUrls: ['./pdf-footer.component.scss'],
})
export class PdfFooterComponent {

  public footerBlocksEnum = PdfSettingsFooterBlocksEnum;
  public footerInfoBlocksEnum = PdfSettingsFooterInfoBlocksEnum;
  public alignEnum = PdfSettingsAlignEnum;

  @Input() pdfSettings: PdfSettingsModel;
  @Input() companyProfile: CompanyProfile;
  @Input() countryTitle: string;
  @Input() bankAccount: BankAccountModel;

  @Output() imageClicked: EventEmitter<null> = new EventEmitter<null>();
  @Output() textClicked: EventEmitter<null> = new EventEmitter<null>();
  @Output() footerInfoClicked: EventEmitter<null> = new EventEmitter<null>();
  @Output() settingsUpdated: EventEmitter<PdfSettingsModel> = new  EventEmitter<PdfSettingsModel>();
  @Output() deleteImageClicked: EventEmitter<null> = new EventEmitter<null>();
  @Output() deleteTextClicked: EventEmitter<null> = new EventEmitter<null>();

  public itemDropped(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.pdfSettings.settings.footer.order, event.previousIndex, event.currentIndex);
    this.settingsUpdated.emit(this.pdfSettings)
  }

  public imageClick(): void {
    this.imageClicked.emit();
  }

  public textClick(): void {
    this.textClicked.emit();
  }

  public footerInfoClick(): void {
    this.footerInfoClicked.emit();
  }

  public deleteImage(): void {
    this.deleteImageClicked.emit();
  }

  public deleteText(): void {
    this.deleteTextClicked.emit();
  }

  get footerInfo(): PdfSettingsFooterInfoModel {
    return this.pdfSettings.settings.footer.footerInfo;
  }

  get text(): PdfSettingsCustomTextModel {
    return this.pdfSettings.settings.footer.text;
  }

  get image(): PdfSettingsCustomImageModel {
    return this.pdfSettings.settings.footer.image;
  }

  get addressInfo(): string {
    return [
      get(this.companyProfile ,'legalAddress.house_number'),
      get(this.companyProfile ,'legalAddress.block'),
      get(this.companyProfile ,'legalAddress.floor'),
      get(this.companyProfile ,'legalAddress.apartments')
    ].filter(i => !!i)
      .join('/');
  }

  get postalCodeCityCountry(): string {
    return [
      get(this.companyProfile, 'legalAddress.zip_code'),
      get(this.companyProfile, 'legalAddress.city'),
      this.countryTitle
    ].filter(i => !!i)
      .join(', ');
  }

}
